// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__k2b5z","col":"Categories_col__wqe7G","colLarge":"Categories_colLarge__tBYuT","row":"Categories_row__27Vzy","heading":"Categories_heading__eGvwG"};